import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentProject, getProjectIdFromUrl } from "../utils/projectUtils";

/**
 * Component that synchronizes Redux project state with URL parameters
 * This should be placed at the root level of the app
 */
const ProjectSync = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const currentStoreProject = useSelector(
    (state) => state.indexReducer?.project
  );

  useEffect(() => {
    const urlProjectId = getProjectIdFromUrl();

    // If URL has a project ID
    if (urlProjectId) {
      // Check if store has a different project or no project
      if (!currentStoreProject || currentStoreProject._id !== urlProjectId) {
        const urlProject = getCurrentProject();

        if (urlProject) {
          console.log(
            "ProjectSync: Updating store with project from URL:",
            urlProject._id
          );
          dispatch({
            type: "PROJECT_SELECTED",
            payload: { project: urlProject },
          });
        }
      }
    }
  }, [location.search, dispatch, currentStoreProject]);

  // This component doesn't render anything
  return null;
};

export default ProjectSync;
